import axios from 'axios'
const API_BASE_URI = process.env.REACT_APP_API ?? '/api'

export const startGameApi = async (data) => {
    const res = await axios.post(`${API_BASE_URI}/start`, data)
    return res.data.id
}

export const pushStateApi = async (data) => {
    const res = await axios.post(`${API_BASE_URI}/save`, data)
    return res.data
}

export const pushFinishApi = async (guid, gameId) => {
    const form = new FormData()
    form.append('guid', guid)
    form.append('game_id', gameId)
    const res = await axios.post(`${API_BASE_URI}/finish`, form)
    return res.data
}

export const pushFinishAllApi = async(guid,games) => {
    const res = await axios.post(`${API_BASE_URI}/v2/finish`, {
        guid,
        games,
    })
    return res.data
}

export const getResult = async(shareId) => {
    const form = new FormData()
    form.append('share_id', shareId)
    const res = await axios.post(`${API_BASE_URI}/result`, form)
    return res.data
}

export const luckySubmitApi = async({guid, fullname, email, phone, address}) => {
    const form = new FormData()

    form.append('guid', guid)
    form.append('fullname', fullname)
    form.append('email', email)
    form.append('phone', phone)
    form.append('address', address)

    const res = await axios.post(`${API_BASE_URI}/lucky`, form)
    return res.data
}